import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useAuthStore } from '~/stores/auth'
// composables/useMenuItems.ts
function addKeys(nodes: any[], prefix = "0") {
  nodes.forEach((node, index) => {
    
    node.icon = node.icon || 'lucide-dot';
    node.key = `${prefix}-${index}`
    if (node.children && node.children.length > 0) {
      addKeys(node.children, node.key)
      //delete node.to
      node.to = "";//Descomentar si se desea poder hacer click desde el menú en los nodos padres.
    }
  })
  return nodes
}

function transformMenu(nodes: any[], t: any): any[] {
  const route = useRoute()

  return nodes.map(node => {
    const children = node.children?.length
      ? transformMenu(node.children, t)
      : undefined

    const active =
      (node.url && route.path.startsWith(node.url)) ||
      children?.some(child => child.active)

    return {
      code: node.code,
      label: t(`${node.code.replace(/-/g, '_')}.object_name_plural`),
      icon: node.icon,
      to: node.url,
      active,
      open: active,
      class: active ? 'pseudo-navbar-active' : '',
      children
    }
  })
}
export function useMenuItems(t: any, locale: any) {
  const authStore = useAuthStore()
  return computed(() => {
    
    if (!authStore.selectedTenant?.menu) return []

    const rootMenu = authStore.selectedTenant.menu
    const menuChildren = rootMenu.children ?? [] // omitimos nodo raíz

    const transformed = transformMenu(menuChildren, t)
    return addKeys(transformed, 'root')
  })
}
